import KitPlusCryo from 'containers/kit-plus-cryo'

export default KitPlusCryo
